export function isValidAccountNumber(acc){
  if (typeof acc !== "string") {
      return false;
  }
  
  for (let i = 0; i < acc.length; i++) {
      if (isNaN(parseInt(acc[i]))) {
          return false;
      }
  }

  return true
}
export function isValidAccountNumberExactDigits(acc,num_digits){
    if (!isValidAccountNumber(acc)) {
        return false;
      }
      return acc.length === num_digits;
}

export function isValidAccountNumberMaxDigits(acc,num_digits){
  if (!isValidAccountNumber(acc)) {
      return false;
    }
  
    return acc.length <= num_digits;
}

export function isValidAccountNumberMinDigits(acc,num_digits){
  if (!isValidAccountNumber(acc)) {
      return false;
    }
  
    return acc.length >= num_digits;
}

export function isValidAccountNumberDigits(acc,num_digits, num_digit_kind){
  if(num_digit_kind=='max'){
    if(!isValidAccountNumberMaxDigits(acc, num_digits)){
      return false
    }
  }else if(num_digit_kind=='min'){
    if(!isValidAccountNumberMinDigits(acc, num_digits)){
     return false
    }
  }else{
    if(!isValidAccountNumberExactDigits(acc, num_digits)){
      return false
    }
  }
  return true
}